const searchIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.4609 7.38462C10.4609 9.08396 9.08335 10.4615 7.38401 10.4615C5.68468 10.4615 4.30709 9.08396 4.30709 7.38462C4.30709 5.68529 5.68468 4.3077 7.38401 4.3077C9.08335 4.3077 10.4609 5.68529 10.4609 7.38462ZM10.1511 11.4571C9.36249 11.9939 8.4099 12.3077 7.38401 12.3077C4.66507 12.3077 2.46094 10.1036 2.46094 7.38462C2.46094 4.66568 4.66507 2.46155 7.38401 2.46155C10.103 2.46155 12.3071 4.66568 12.3071 7.38462C12.3071 8.41051 11.9932 9.3631 11.4565 10.1517L14.4982 13.1935C14.8587 13.554 14.8587 14.1383 14.4982 14.4988C14.1377 14.8593 13.5534 14.8593 13.1929 14.4988L10.1511 11.4571Z"
			fill="#858699"
		/>
	</svg>
);
const todo = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7 2.625C4.58375 2.625 2.625 4.58375 2.625 7C2.625 9.41625 4.58375 11.375 7 11.375C9.41625 11.375 11.375 9.41625 11.375 7C11.375 4.58375 9.41625 2.625 7 2.625ZM0.875 7C0.875 3.61726 3.61726 0.875 7 0.875C10.3827 0.875 13.125 3.61726 13.125 7C13.125 10.3827 10.3827 13.125 7 13.125C3.61726 13.125 0.875 10.3827 0.875 7Z"
			fill="#EEEFFC"
		/>
	</svg>
);
const inProgress = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.99622 12.1304C9.83132 12.1304 12.1296 9.83217 12.1296 6.99708C12.1296 4.16201 9.83132 1.86375 6.99622 1.86375C4.16116 1.86375 1.86289 4.16201 1.86289 6.99708C1.86289 9.83217 4.16116 12.1304 6.99622 12.1304ZM6.99622 13.5304C10.6045 13.5304 13.5296 10.6053 13.5296 6.99708C13.5296 3.38882 10.6045 0.463745 6.99622 0.463745C3.38797 0.463745 0.462891 3.38882 0.462891 6.99708C0.462891 10.6053 3.38797 13.5304 6.99622 13.5304Z"
			fill="#F2C94C"
		/>
		<path
			d="M10.3296 6.99708C10.3296 8.83803 8.8372 10.3304 6.99625 10.3304L6.99602 3.66375C8.83697 3.66375 10.3296 5.15613 10.3296 6.99708Z"
			fill="#F2C94C"
		/>
	</svg>
);
const done = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7 13.125C10.3828 13.125 13.125 10.3828 13.125 7C13.125 3.61726 10.3828 0.875 7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3828 3.61726 13.125 7 13.125ZM10.3107 5.62538C10.5751 5.3262 10.5608 4.8563 10.2788 4.57583C9.9967 4.29535 9.55378 4.31051 9.28935 4.60968L6.25556 8.04232L4.66506 6.54264C4.37611 6.27019 3.93366 6.2978 3.67682 6.6043C3.41998 6.9108 3.446 7.38014 3.73496 7.65258L5.49528 9.31236C5.96786 9.758 6.68905 9.72318 7.1215 9.23388L10.3107 5.62538Z"
			fill="#5E6AD2"
		/>
	</svg>
);
const listIcon = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13 2H12C11.4477 2 11 2.44772 11 3V13C11 13.5523 11.4477 14 12 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z"
			fill="#858699"
		/>
		<path
			d="M3 8H2C1.44772 8 1 8.44772 1 9V13C1 13.5523 1.44772 14 2 14H3C3.55228 14 4 13.5523 4 13V9C4 8.44772 3.55228 8 3 8Z"
			fill="#858699"
		/>
		<path
			d="M8 5H7C6.44772 5 6 5.44772 6 6V13C6 13.5523 6.44772 14 7 14H8C8.55228 14 9 13.5523 9 13V6C9 5.44772 8.55228 5 8 5Z"
			fill="#858699"
		/>
	</svg>
);
const check = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="0.5" y="0.5" width="13" height="13" rx="2.5" fill="#575BC7" />
		<rect x="0.5" y="0.5" width="13" height="13" rx="2.5" stroke="#37466C" />
		<path
			d="M10.5 5L5.5 10L3.5 8"
			stroke="white"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const network = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2008_1339)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7 0.875C10.3827 0.875 13.125 3.61726 13.125 7C13.125 10.3827 10.3827 13.125 7 13.125C3.61726 13.125 0.875 10.3827 0.875 7C0.875 3.61726 3.61726 0.875 7 0.875ZM6.4854 11.7853C6.58612 11.7961 6.67188 11.7156 6.67188 11.6143V9.71416C6.67188 9.61275 6.58599 9.53234 6.48523 9.54319C6.00874 9.59464 5.56945 9.71521 5.19069 9.8819C5.11063 9.91716 5.07251 10.0082 5.10153 10.0907C5.22125 10.4311 5.35761 10.7443 5.5056 11.025C5.62809 11.2573 5.75609 11.4627 5.88577 11.6404C5.91008 11.6737 5.94585 11.6969 5.98619 11.7055C6.14967 11.7406 6.31623 11.7674 6.4854 11.7853ZM7.51477 9.54319C7.41402 9.53234 7.32812 9.61275 7.32812 9.71416V11.6143C7.32812 11.7156 7.41388 11.7961 7.5146 11.7853C7.68377 11.7674 7.85033 11.7406 8.01381 11.7055C8.05415 11.6969 8.08992 11.6737 8.11423 11.6404C8.24391 11.4627 8.37191 11.2573 8.4944 11.025C8.64239 10.7443 8.77879 10.4311 8.89849 10.0907C8.92745 10.0082 8.88939 9.91716 8.80932 9.8819C8.43055 9.71521 7.99126 9.59464 7.51477 9.54319ZM7.49249 8.8816C7.40029 8.8732 7.32812 8.79699 7.32812 8.70439V7.50312C7.32812 7.40647 7.40647 7.32812 7.50312 7.32812H9.22005C9.31892 7.32812 9.39829 7.41006 9.3933 7.50884C9.3646 8.069 9.28979 8.60375 9.17945 9.1014C9.15565 9.2085 9.03901 9.26476 8.93716 9.22381C8.5022 9.0489 8.01293 8.92867 7.49249 8.8816ZM6.49688 6.67188C6.59353 6.67188 6.67188 6.59353 6.67188 6.49688V5.29561C6.67188 5.20304 6.59971 5.12678 6.50751 5.11843C5.98707 5.07133 5.4978 4.95113 5.0628 4.77621C4.96101 4.73526 4.84431 4.79147 4.82057 4.89858C4.71025 5.39625 4.63536 5.931 4.60674 6.49116C4.60169 6.58994 4.68109 6.67188 4.77999 6.67188H6.49688ZM7.49249 5.11843C7.40029 5.12678 7.32812 5.20304 7.32812 5.29561V6.49688C7.32812 6.59353 7.40647 6.67188 7.50312 6.67188H9.22005C9.31892 6.67188 9.39829 6.58994 9.3933 6.49116C9.3646 5.931 9.28979 5.39625 9.17945 4.89858C9.15565 4.79147 9.03901 4.73526 8.93716 4.7762C8.5022 4.95112 8.01293 5.07132 7.49249 5.11843ZM7.51477 4.4568C7.41402 4.46766 7.32812 4.38721 7.32812 4.28587V2.38569C7.32812 2.28442 7.41388 2.20398 7.5146 2.21469C7.68377 2.23268 7.85033 2.25943 8.01381 2.29448C8.05415 2.30312 8.08992 2.32626 8.11423 2.35959C8.24391 2.53733 8.37191 2.74272 8.4944 2.97504C8.64239 3.25573 8.77879 3.56894 8.89849 3.90928C8.92745 3.9918 8.88939 4.08284 8.80932 4.11808C8.43055 4.28482 7.99126 4.40539 7.51477 4.4568ZM6.48523 4.4568C6.58599 4.46767 6.67188 4.38721 6.67188 4.28587V2.38569C6.67188 2.28442 6.58612 2.20398 6.4854 2.21469C6.31622 2.23268 6.14967 2.25943 5.98618 2.29448C5.94584 2.30312 5.91008 2.32626 5.88577 2.35959C5.75608 2.53733 5.62809 2.74272 5.5056 2.97504C5.35761 3.25573 5.22125 3.56894 5.10153 3.90928C5.07251 3.9918 5.11063 4.08284 5.19069 4.11809C5.56945 4.28482 6.00874 4.40539 6.48523 4.4568ZM6.50751 8.8816C6.59971 8.8732 6.67188 8.79699 6.67188 8.70439V7.50312C6.67188 7.40647 6.59353 7.32812 6.49688 7.32812H4.77999C4.68109 7.32812 4.60169 7.41006 4.60674 7.50884C4.63536 8.069 4.71025 8.60375 4.82057 9.1014C4.84431 9.2085 4.96101 9.26476 5.0628 9.22381C5.4978 9.0489 5.98707 8.92867 6.50751 8.8816ZM9.70471 10.4619C9.61826 10.3786 9.47861 10.4192 9.43565 10.5312C9.32356 10.8233 9.19949 11.0965 9.06614 11.3477C9.39068 11.1932 9.69526 11.0034 9.97474 10.7832C9.90404 10.6751 9.81409 10.5671 9.70471 10.4619ZM10.6073 10.1856C10.5352 10.2673 10.4069 10.258 10.3358 10.1755C10.1895 10.006 10.0167 9.84979 9.82546 9.70996C9.76535 9.66604 9.73682 9.59026 9.75502 9.51816C9.91279 8.89341 10.0174 8.21289 10.0509 7.49769C10.0552 7.40325 10.1326 7.32812 10.2271 7.32812H11.6143C11.7156 7.32812 11.7961 7.41394 11.7853 7.51464C11.677 8.53368 11.2506 9.4577 10.6073 10.1856ZM4.17457 9.70996C4.23464 9.66604 4.26317 9.59026 4.24495 9.51816C4.08724 8.89341 3.98269 8.21289 3.94915 7.49769C3.94473 7.40325 3.86743 7.32812 3.77288 7.32812H2.38569C2.28442 7.32812 2.20398 7.41394 2.21469 7.51464C2.32303 8.53368 2.74942 9.4577 3.3927 10.1856C3.46486 10.2673 3.59309 10.258 3.66426 10.1755C3.81043 10.006 3.98327 9.84979 4.17457 9.70996ZM4.02523 10.7832C4.30478 11.0034 4.60932 11.1932 4.9339 11.3477C4.80052 11.0965 4.67647 10.8233 4.56436 10.5312C4.52134 10.4192 4.38173 10.3786 4.29527 10.4619C4.18592 10.5671 4.09598 10.6751 4.02523 10.7832ZM4.9339 2.65233C4.80052 2.90355 4.67647 3.17672 4.56436 3.46875C4.52134 3.58079 4.38173 3.62134 4.29527 3.53812C4.18592 3.43286 4.09598 3.32494 4.02523 3.21677C4.30478 2.99666 4.60932 2.80686 4.9339 2.65233ZM4.24495 4.48186C4.26317 4.40972 4.23464 4.33398 4.17457 4.29007C3.98327 4.15021 3.81043 3.994 3.66426 3.82456C3.59309 3.74205 3.46486 3.73274 3.3927 3.8144C2.74942 4.54227 2.32303 5.46632 2.21469 6.48536C2.20398 6.58606 2.28442 6.67188 2.38569 6.67188H3.77288C3.86743 6.67188 3.94473 6.59675 3.94915 6.50231C3.98269 5.78711 4.08724 5.10659 4.24495 4.48186ZM10.2271 6.67188C10.1326 6.67188 10.0552 6.59675 10.0509 6.50231C10.0174 5.78711 9.91279 5.10659 9.75502 4.48186C9.73682 4.40972 9.76535 4.33398 9.82546 4.29007C10.0167 4.15021 10.1895 3.994 10.3358 3.82456C10.4069 3.74205 10.5352 3.73274 10.6073 3.8144C11.2506 4.54227 11.677 5.46632 11.7853 6.48536C11.7961 6.58606 11.7156 6.67188 11.6143 6.67188H10.2271ZM9.97474 3.21677C9.90404 3.32494 9.81409 3.43286 9.70471 3.53812C9.61826 3.62134 9.47861 3.58079 9.43565 3.46875C9.32356 3.17672 9.19949 2.90355 9.06614 2.65233C9.39068 2.80685 9.69526 2.99665 9.97474 3.21677Z"
				fill="#00B2BF"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2008_1339">
				<rect width="14" height="14" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const expand = (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.37 14.63C13.4929 14.753 13.5619 14.9198 13.5619 15.0938C13.5619 15.2677 13.4929 15.4345 13.37 15.5575L11.375 17.5L12.4688 18.5938C12.4688 18.7678 12.3996 18.9347 12.2765 19.0578C12.1535 19.1809 11.9865 19.25 11.8125 19.25H9.40625C9.2322 19.25 9.06528 19.1809 8.94221 19.0578C8.81914 18.9347 8.75 18.7678 8.75 18.5938V16.1875C8.75 16.0135 8.81914 15.8465 8.94221 15.7235C9.06528 15.6004 9.2322 15.5313 9.40625 15.5313L10.5 16.625L12.4425 14.63C12.5655 14.5071 12.7323 14.4381 12.9063 14.4381C13.0802 14.4381 13.247 14.5071 13.37 14.63ZM14.63 13.37C14.5071 13.247 14.4381 13.0802 14.4381 12.9063C14.4381 12.7323 14.5071 12.5655 14.63 12.4425L16.625 10.5L15.5313 9.40625C15.5313 9.2322 15.6004 9.06528 15.7235 8.94221C15.8465 8.81914 16.0135 8.75 16.1875 8.75H18.5938C18.7678 8.75 18.9347 8.81914 19.0578 8.94221C19.1809 9.06528 19.25 9.2322 19.25 9.40625V11.8125C19.25 11.9865 19.1809 12.1535 19.0578 12.2765C18.9347 12.3996 18.7678 12.4688 18.5938 12.4688L17.5 11.375L15.5575 13.37C15.4345 13.4929 15.2677 13.5619 15.0938 13.5619C14.9198 13.5619 14.753 13.4929 14.63 13.37Z"
			fill="#858699"
		/>
	</svg>
);
const close = (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.59846 9.59846C9.85474 9.34218 10.2703 9.34218 10.5265 9.59846L14 13.0716L17.4735 9.59846C17.7298 9.34218 18.1452 9.34218 18.4015 9.59846C18.6578 9.85474 18.6578 10.2703 18.4015 10.5265L14.9284 14L18.4015 17.4735C18.6345 17.7064 18.6557 18.071 18.465 18.3279L18.4015 18.4015C18.1452 18.6578 17.7298 18.6578 17.4735 18.4015L14 14.9284L10.5265 18.4015C10.2703 18.6578 9.85474 18.6578 9.59846 18.4015C9.34218 18.1452 9.34218 17.7298 9.59846 17.4735L13.0716 14L9.59846 10.5265C9.36548 10.2936 9.3443 9.92897 9.53492 9.67206L9.59846 9.59846Z"
			fill="#858699"
		/>
	</svg>
);
const chevron = (
	<svg
		width="5"
		height="10"
		viewBox="0 0 5 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2008_1342)">
			<path
				d="M0.519158 7.40948C0.407256 7.52698 0.345724 7.68357 0.347702 7.84582C0.349681 8.00806 0.415012 8.16311 0.529746 8.27784C0.64448 8.39257 0.799523 8.45791 0.961769 8.45988C1.12401 8.46186 1.28061 8.40033 1.3981 8.28843L4.06569 5.62084C4.14734 5.53929 4.21211 5.44245 4.2563 5.33586C4.30049 5.22926 4.32324 5.115 4.32324 4.99961C4.32324 4.88422 4.30049 4.76996 4.2563 4.66336C4.21211 4.55677 4.14734 4.45993 4.06569 4.37838L1.3981 1.71172C1.2806 1.59982 1.12401 1.53829 0.961769 1.54027C0.799523 1.54225 0.644479 1.60758 0.529746 1.72231C0.415012 1.83704 0.349681 1.99209 0.347702 2.15433C0.345724 2.31658 0.407255 2.47317 0.519157 2.59067L2.9267 5.00008L0.519158 7.40948Z"
				fill="#DCD8FE"
				fill-opacity="0.565"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2008_1342">
				<rect
					width="8.38865"
					height="4.66036"
					fill="white"
					transform="translate(0 9.19434) rotate(-90)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const attachment = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12.6422 7.69048L8.92852 11.4041C7.48092 12.8517 5.34274 13.0101 4.16594 11.8333C2.9866 10.654 3.14375 8.52219 4.59144 7.07451L8.00134 3.66461C8.93484 2.73109 10.2969 2.63095 11.0326 3.36667C11.7674 4.10139 11.6651 5.4675 10.7354 6.39727L7.32291 9.8097C6.9013 10.2313 6.32099 10.2741 6.02309 9.97619C5.72579 9.6789 5.76877 9.09718 6.19818 8.66776L9.28975 5.57619C9.5659 5.30005 9.5659 4.85233 9.28975 4.57619C9.01361 4.30005 8.5659 4.30005 8.28975 4.57619L5.19818 7.66776C4.24665 8.6193 4.13792 10.091 5.02308 10.9762C5.90877 11.8619 7.37912 11.7535 8.32291 10.8097L11.7354 7.39727C13.1869 5.94573 13.3557 3.68975 12.0326 2.36667C10.7092 1.04326 8.4571 1.20884 7.00134 2.66461L3.59143 6.07451C1.62156 8.04437 1.39883 11.0662 3.16595 12.8333C4.93074 14.5981 7.95887 14.3737 9.92852 12.4041L13.6422 8.69048C13.9183 8.41433 13.9183 7.96662 13.6422 7.69048C13.366 7.41433 12.9183 7.41433 12.6422 7.69048Z"
			fill="currentColor"
		/>
	</svg>
);
const twolevel = (
	<svg
		width="13"
		height="10"
		viewBox="0 0 13 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect y="0.5" width="9" height="9" rx="4.5" fill="#BB87FC" />
		<rect
			x="0.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="#52526F"
			stroke-opacity="0.44"
		/>
		<rect
			x="0.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="black"
			stroke-opacity="0.2"
		/>
		<rect
			x="0.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="black"
			stroke-opacity="0.2"
		/>
		<rect x="4" y="0.5" width="9" height="9" rx="4.5" fill="#4EA7FC" />
		<rect
			x="4.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="#52526F"
			stroke-opacity="0.44"
		/>
		<rect
			x="4.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="black"
			stroke-opacity="0.2"
		/>
		<rect
			x="4.5"
			y="1"
			width="8"
			height="8"
			rx="4"
			stroke="black"
			stroke-opacity="0.2"
		/>
	</svg>
);
const ellipsis = (
	<svg
		width="12"
		height="3"
		viewBox="0 0 12 3"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.625 0.1875C1.9731 0.1875 2.30694 0.325781 2.55308 0.571922C2.79922 0.818064 2.9375 1.1519 2.9375 1.5C2.9375 1.8481 2.79922 2.18194 2.55308 2.42808C2.30694 2.67422 1.9731 2.8125 1.625 2.8125C1.2769 2.8125 0.943064 2.67422 0.696922 2.42808C0.450781 2.18194 0.3125 1.8481 0.3125 1.5C0.3125 1.1519 0.450781 0.818064 0.696922 0.571922C0.943064 0.325781 1.2769 0.1875 1.625 0.1875ZM6 0.1875C6.3481 0.1875 6.68194 0.325781 6.92808 0.571922C7.17422 0.818064 7.3125 1.1519 7.3125 1.5C7.3125 1.8481 7.17422 2.18194 6.92808 2.42808C6.68194 2.67422 6.3481 2.8125 6 2.8125C5.6519 2.8125 5.31806 2.67422 5.07192 2.42808C4.82578 2.18194 4.6875 1.8481 4.6875 1.5C4.6875 1.1519 4.82578 0.818064 5.07192 0.571922C5.31806 0.325781 5.6519 0.1875 6 0.1875ZM10.375 0.1875C10.7231 0.1875 11.0569 0.325781 11.3031 0.571922C11.5492 0.818064 11.6875 1.1519 11.6875 1.5C11.6875 1.8481 11.5492 2.18194 11.3031 2.42808C11.0569 2.67422 10.7231 2.8125 10.375 2.8125C10.0269 2.8125 9.69306 2.67422 9.44692 2.42808C9.20078 2.18194 9.0625 1.8481 9.0625 1.5C9.0625 1.1519 9.20078 0.818064 9.44692 0.571922C9.69306 0.325781 10.0269 0.1875 10.375 0.1875Z"
			fill="#EEEFFC"
		/>
	</svg>
);
const userIcon = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9 16.875C11.0886 16.875 13.0916 16.0453 14.5685 14.5685C16.0453 13.0916 16.875 11.0886 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95468 11.0886 1.125 9 1.125C6.91142 1.125 4.90838 1.95468 3.43153 3.43153C1.95468 4.90838 1.125 6.91142 1.125 9C1.125 11.0886 1.95468 13.0916 3.43153 14.5685C4.90838 16.0453 6.91142 16.875 9 16.875ZM5.76112 12.2389L4.62487 13.3751C3.75951 12.5098 3.17018 11.4073 2.93141 10.207C2.69264 9.00676 2.81516 7.76265 3.28347 6.63201C3.75178 5.50138 4.54484 4.53501 5.56238 3.8551C6.57991 3.1752 7.77622 2.8123 9 2.8123C10.2238 2.8123 11.4201 3.1752 12.4376 3.8551C13.4552 4.53501 14.2482 5.50138 14.7165 6.63201C15.1848 7.76265 15.3074 9.00676 15.0686 10.207C14.8298 11.4073 14.2405 12.5098 13.3751 13.3751L12.2389 12.2389C11.9254 11.9253 11.5532 11.6766 11.1436 11.5069C10.734 11.3373 10.295 11.2499 9.85162 11.25H8.14837C7.70501 11.2499 7.26598 11.3373 6.85637 11.5069C6.44675 11.6766 6.07458 11.9253 5.76112 12.2389Z"
			fill="#858699"
		/>
		<path
			d="M9 4.5C8.40326 4.5 7.83097 4.73705 7.40901 5.15901C6.98705 5.58097 6.75 6.15326 6.75 6.75V7.3125C6.75 7.90924 6.98705 8.48153 7.40901 8.90349C7.83097 9.32545 8.40326 9.5625 9 9.5625C9.59674 9.5625 10.169 9.32545 10.591 8.90349C11.0129 8.48153 11.25 7.90924 11.25 7.3125V6.75C11.25 6.15326 11.0129 5.58097 10.591 5.15901C10.169 4.73705 9.59674 4.5 9 4.5Z"
			fill="#858699"
		/>
	</svg>
);
const bug = (
	<svg
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="0.5" y="0.5" width="9" height="9" rx="4.5" fill="#EB5757" />
	</svg>
);
const file = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.75 1V6.75C6.75 7.5297 7.34489 8.17045 8.10554 8.24313L8.25 8.25H14V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V3C2 1.89543 2.89543 1 4 1H6.75ZM8 1L14 7.03022H9C8.44772 7.03022 8 6.5825 8 6.03022V1Z"
			fill="#DCD8FE"
			fill-opacity="0.314"
		/>
	</svg>
);
const inbox = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.5914 1.5C11.9984 1.5 13.2164 2.47789 13.5205 3.85169L14.8819 10.0023C14.9604 10.3571 15 10.7195 15 11.0829V13.0181C15 14.3888 13.8888 15.5 12.5181 15.5H3.48193C2.1112 15.5 1 14.3888 1 13.0181V11.0829C1 10.7195 1.03962 10.3571 1.11815 10.0023L2.47949 3.85169C2.78356 2.47789 4.00156 1.5 5.4086 1.5H10.5914ZM10.5914 3H5.4086C4.70508 3 4.09608 3.48894 3.94405 4.17584L2.5827 10.3265L2.548 10.51L5.01028 10.5108C5.55851 10.5108 6.00293 10.9552 6.00293 11.5034C6.00293 12.0517 6.44735 12.4961 6.99557 12.4961H9.05948C9.6077 12.4961 10.0521 12.0517 10.0521 11.5034C10.0521 10.9552 10.4965 10.5108 11.0448 10.5108L13.4528 10.5102C13.4426 10.4487 13.4308 10.3874 13.4173 10.3265L12.056 4.17584C11.9039 3.48894 11.2949 3 10.5914 3Z"
			fill="currentColor"
		/>
	</svg>
);
const myIssues = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14.2458 10.5C14.6255 10.5 14.9393 10.7822 14.9889 11.1482L14.9958 11.25V12.7475C14.9958 14.2083 13.8567 15.4034 12.4177 15.4922L12.2504 15.4975L10.7513 15.5C10.3371 15.5007 10.0007 15.1655 10 14.7513C9.99936 14.3716 10.281 14.0573 10.647 14.007L10.7487 14L12.2479 13.9975C12.8943 13.9964 13.4255 13.5047 13.4893 12.8751L13.4958 12.7475V11.25C13.4958 10.8358 13.8316 10.5 14.2458 10.5ZM1.75 10.5C2.16421 10.5 2.5 10.8358 2.5 11.25V12.7475C2.5 13.437 3.05836 13.9963 3.74789 13.9975L5.24703 14C5.66125 14.0007 5.99646 14.3371 5.99576 14.7513C5.99506 15.1655 5.65871 15.5007 5.2445 15.5L3.74535 15.4975C2.22839 15.4949 1 14.2644 1 12.7475V11.25C1 10.8358 1.33579 10.5 1.75 10.5ZM8 6.5C9.10457 6.5 10 7.39543 10 8.5C10 9.60457 9.10457 10.5 8 10.5C6.89543 10.5 6 9.60457 6 8.5C6 7.39543 6.89543 6.5 8 6.5ZM10.7513 1.5L12.2504 1.50254C13.7674 1.5051 14.9958 2.73556 14.9958 4.25253V5.75C14.9958 6.16422 14.66 6.5 14.2458 6.5C13.8316 6.5 13.4958 6.16422 13.4958 5.75V4.25253C13.4958 3.563 12.9374 3.0037 12.2479 3.00253L10.7487 3C10.3345 2.9993 9.9993 2.66295 10 2.24873C10.0007 1.83452 10.3371 1.4993 10.7513 1.5ZM5.24873 1.5C5.66295 1.4993 5.9993 1.83452 6 2.24873C6.0007 2.66295 5.66548 2.9993 5.25127 3L3.75212 3.00253C3.06259 3.0037 2.50424 3.563 2.50424 4.25253V5.75C2.50424 6.16422 2.16845 6.5 1.75424 6.5C1.34002 6.5 1.00424 6.16422 1.00424 5.75V4.25253C1.00424 2.73556 2.23262 1.5051 3.74959 1.50254L5.24873 1.5Z"
			fill="currentColor"
		/>
	</svg>
);
const views = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.6541 11.2952L14.7544 12.1213C14.8576 12.1618 14.9394 12.2434 14.9801 12.3466C15.0511 12.5264 14.9828 12.7268 14.827 12.8284L14.755 12.8656L8.35645 15.3924C8.15935 15.4703 7.94372 15.4831 7.74052 15.4309L7.62035 15.3918L1.25259 12.8653C1.1499 12.8246 1.06864 12.7432 1.02806 12.6404C0.95707 12.4607 1.02536 12.2603 1.1812 12.1587L1.25319 12.1215L3.34307 11.2962L7.06917 12.7751C7.65895 13.0091 8.31525 13.0097 8.9054 12.7766L12.6541 11.2952ZM12.6541 7.27688L14.7544 8.10289C14.8576 8.14346 14.9394 8.22508 14.9801 8.32824C15.0511 8.50803 14.9828 8.70839 14.827 8.81004L14.755 8.8472L10.6001 10.4882L9.619 10.875L8.35645 11.3741L8.317 11.386L8.23566 11.4132C8.20301 11.4215 8.17004 11.4282 8.13688 11.4331C8.12585 11.4346 8.11547 11.436 8.10507 11.4372C8.02541 11.4468 7.94422 11.4464 7.86397 11.4363L7.74052 11.4126L7.62035 11.3735L6.391 10.885L5.38907 10.4882L1.25259 8.84697C1.1499 8.80623 1.06864 8.72483 1.02806 8.62208C0.95707 8.44229 1.02536 8.24192 1.1812 8.14029L1.25319 8.10312L3.34307 7.27788L7.06917 8.75677C7.65895 8.99078 8.31525 8.9913 8.9054 8.75824L12.6541 7.27688ZM7.62186 1.56989C7.85734 1.47691 8.11932 1.4767 8.35494 1.56931L14.7544 4.08452C14.8576 4.12509 14.9394 4.20671 14.9801 4.30987C15.0612 4.51534 14.9605 4.74769 14.755 4.82884L10.6001 6.46988L8.35565 7.356L8.27468 7.38396C8.25405 7.3901 8.23326 7.39557 8.21236 7.40036C8.09824 7.42674 7.98013 7.43258 7.86397 7.41788L7.74052 7.39419L7.62035 7.3551L1.25259 4.8286C1.1499 4.78786 1.06864 4.70646 1.02806 4.60371C0.946927 4.39823 1.04772 4.16589 1.25319 4.08475L7.62186 1.56989Z"
			fill="currentColor"
		/>
	</svg>
);
const roadmaps = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5 13.5001L4.99998 1.50018L1.40251 3.54575C1.15509 3.67511 1 3.9312 1 4.2104V14.7502C1 15.0204 1.14535 15.2697 1.38048 15.4028C1.61562 15.536 1.90419 15.5323 2.13588 15.3933L5 13.5001Z"
			fill="currentColor"
		/>
		<path
			d="M6 1.50018V13.5001L9.99998 15.5001V3.50209L6 1.50018Z"
			fill="currentColor"
		/>
		<path
			d="M14.6935 12.605L11 15.5001V3.50209L13.8641 1.60697C14.0958 1.46795 14.3844 1.46431 14.6195 1.59744C14.8547 1.73057 15 1.97989 15 2.25009V12.0002C15 12.2391 14.8862 12.4637 14.6935 12.605Z"
			fill="currentColor"
		/>
	</svg>
);
const workspace = (
	<svg
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
				<stop offset="0%" style={{ stopColor: '#FF7F50', stopOpacity: 1 }} />
				<stop offset="100%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
			</linearGradient>
		</defs>
		<rect y="0.5" width="18" height="18" rx="4" fill="" />
		<circle
			cx="9"
			cy="9.5"
			r="6.125"
			fill="url(#grad1)"
		/>
	</svg>
);
const workspace2 = (
	<svg
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
				<stop offset="0%" style={{ stopColor: '#BB87FC', stopOpacity: 1 }} />
				<stop offset="100%" style={{ stopColor: '#1E90FF', stopOpacity: 1 }} />
			</linearGradient>
		</defs>
		<rect y="0.5" width="18" height="18" rx="4" fill="" />
		<circle
			cx="9"
			cy="9.5"
			r="6.125"
			fill="url(#grad)"
		/>
	</svg>
);
const workspace3 = (
	<svg
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
				<stop offset="0%" style={{ stopColor: '#BB87FC', stopOpacity: 1 }} />
				<stop offset="100%" style={{ stopColor: '#272832', stopOpacity: 1 }} />
			</linearGradient>
		</defs>
		<rect y="0.5" width="18" height="18" rx="4" fill="" />
		<circle
			cx="9"
			cy="9.5"
			r="6.125"
			fill="url(#grad3)"
		/>
	</svg>

);

const help = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2034_2277)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2.32472 1.79362C2.452 1.18555 2.98815 0.75 3.60939 0.75H9.00015C9.1671 0.75 9.3255 0.824228 9.43237 0.952583C9.53925 1.08094 9.58358 1.25014 9.55328 1.4144L8.24078 8.53942C8.18505 8.84212 7.8966 9.04327 7.59412 8.9922C7.56352 8.9973 7.5321 9 7.5 9H2.4375C2.12684 9 1.875 9.25185 1.875 9.5625C1.875 9.87315 2.12684 10.125 2.4375 10.125H7.94625C8.3964 10.125 8.78295 9.80513 8.86718 9.36292L10.1349 2.70726C10.1931 2.40208 10.4875 2.20182 10.7927 2.25994C11.0979 2.31808 11.2982 2.61259 11.2401 2.91776L9.9723 9.57345C9.78705 10.5462 8.93655 11.25 7.94625 11.25H2.4375C1.50552 11.25 0.75 10.4945 0.75 9.5625C0.75 9.52245 0.751395 9.48277 0.75414 9.4434C0.746831 9.38377 0.749042 9.3219 0.762045 9.2598L2.32472 1.79362ZM4.01965 2.25C3.85825 2.25 3.71495 2.35329 3.6639 2.50642L3.5389 2.88142C3.45796 3.12424 3.63869 3.375 3.89465 3.375H6.85408C7.0155 3.375 7.1588 3.27171 7.20984 3.11858L7.33484 2.74358C7.41578 2.50076 7.23505 2.25 6.97909 2.25H4.01965Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2034_2277">
				<rect width="12" height="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const plus = (
	<svg
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.46875 1.875C5.46875 1.61612 5.25888 1.40625 5 1.40625C4.74112 1.40625 4.53125 1.61612 4.53125 1.875V4.53125H1.875C1.61612 4.53125 1.40625 4.74112 1.40625 5C1.40625 5.25888 1.61612 5.46875 1.875 5.46875H4.53125V8.125C4.53125 8.38387 4.74112 8.59375 5 8.59375C5.25888 8.59375 5.46875 8.38387 5.46875 8.125V5.46875H8.125C8.38387 5.46875 8.59375 5.25888 8.59375 5C8.59375 4.74112 8.38387 4.53125 8.125 4.53125H5.46875V1.875Z"
			fill="currentColor"
		/>
	</svg>
);
const issue = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2034_2282)">
			<path
				d="M3.1875 0.75C2.54103 0.75 1.92105 1.00681 1.46393 1.46393C1.00681 1.92105 0.75 2.54103 0.75 3.1875V6.5625C0.75 7.20897 1.00681 7.82895 1.46393 8.28607C1.92105 8.74319 2.54103 9 3.1875 9H6.5625C7.20897 9 7.82895 8.74319 8.28607 8.28607C8.74319 7.82895 9 7.20897 9 6.5625V3.1875C9 2.54103 8.74319 1.92105 8.28607 1.46393C7.82895 1.00681 7.20897 0.75 6.5625 0.75H3.1875ZM1.875 3.1875C1.875 2.463 2.463 1.875 3.1875 1.875H6.5625C7.287 1.875 7.875 2.463 7.875 3.1875V6.5625C7.875 6.9106 7.73672 7.24444 7.49058 7.49058C7.24444 7.73672 6.9106 7.875 6.5625 7.875H3.1875C2.8394 7.875 2.50556 7.73672 2.25942 7.49058C2.01328 7.24444 1.875 6.9106 1.875 6.5625V3.1875ZM3.78225 10.602C3.417 10.2638 3.735 9.75 4.23375 9.75C4.41675 9.75 4.58775 9.82875 4.74225 9.92625C4.944 10.0522 5.1825 10.125 5.4375 10.125H8.8125C9.17025 10.125 9.495 9.9825 9.73125 9.75H9.75V9.73125C9.9825 9.49425 10.125 9.17025 10.125 8.8125V5.4375C10.125 5.1825 10.0522 4.944 9.92625 4.74225C9.82875 4.58775 9.75 4.41675 9.75 4.23375C9.75 3.73575 10.263 3.41625 10.602 3.78225C11.004 4.21725 11.25 4.7985 11.25 5.4375V8.8125C11.25 9.1326 11.187 9.44956 11.0645 9.74529C10.942 10.041 10.7624 10.3097 10.5361 10.5361C10.3097 10.7624 10.041 10.942 9.74529 11.0645C9.44956 11.187 9.1326 11.25 8.8125 11.25H5.4375C4.82368 11.2509 4.23228 11.0194 3.78225 10.602Z"
				fill="#575BC7"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2034_2282">
				<rect width="12" height="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const chevronLeft = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={1.5}
		stroke="currentColor"
		className="size-6"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
		/>
	</svg>
);
const chevronRight = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={1.5}
		stroke="currentColor"
		className="size-6"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
		/>
	</svg>
);
export const icons = {
	searchIcon,
	todo,
	inProgress,
	done,
	listIcon,
	check,
	network,
	expand,
	close,
	chevron,
	attachment,
	twolevel,
	ellipsis,
	userIcon,
	bug,
	file,
	inbox,
	myIssues,
	views,
	roadmaps,
	workspace,
	workspace2,
	workspace3,
	help,
	plus,
	issue,
	chevronLeft,
	chevronRight,
};
